


$('.qlist.singleop').on('click', 'li', function() {
  $(this).addClass('active').siblings().removeClass('active').addClass('notactive');
});
 
$('.third .qlist li').click(function() {
    $(this).toggleClass("active");
  });
 


$('.xxx').click(function() {
    var $group = $(this).closest('.colors');
    $('.color', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.one').fadeOut();
  $('.slide.two').delay(300).fadeIn();
  slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
  $(".progbar div").removeClass();
  $(".progbar div").addClass("bar two");
  });
 